import { AiToneAndVoiceSettingsSchemaRaw } from "@redotech/redo-concierge-settings-common/ai-tone-and-voice";
import * as z from "zod";

const getAiToneAndVoiceSettingsInput = z.object({});

const getAiToneAndVoiceSettingsOutput = AiToneAndVoiceSettingsSchemaRaw;

export const getAiToneAndVoiceSettings: {
  name: "getAiToneAndVoiceSettings";
  input: typeof getAiToneAndVoiceSettingsInput;
  output: typeof getAiToneAndVoiceSettingsOutput;
} = {
  name: "getAiToneAndVoiceSettings" as const,
  input: getAiToneAndVoiceSettingsInput,
  output: getAiToneAndVoiceSettingsOutput,
};
